var regions = {
  "london-central": {
    "rid": "london-central", 
    "codes": {
      "E": [
        2, 
        14
      ], 
      "SW": [
        1, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        13, 
        18
      ], 
      "N": [
        1, 
        5, 
        7
      ], 
      "W": [
        1, 
        2, 
        3, 
        4, 
        6, 
        8, 
        9, 
        10, 
        11, 
        12, 
        14
      ], 
      "SE": [
        1, 
        11, 
        16, 
        17
      ], 
      "NW": [
        1, 
        5, 
        6, 
        8
      ]
    }, 
    "name": "London - Central - Other"
  }, 
  "wales-north": {
    "rid": "wales-north", 
    "codes": {
      "LL": null
    }, 
    "name": "North Wales - LL"
  }, 
  "england-other": {
    "rid": "england-other", 
    "codes": {
      "BD": null, 
      "DN": null, 
      "DL": null, 
      "SL": null, 
      "BA": null, 
      "DH": null, 
      "WF": null, 
      "BL": null, 
      "FY": null, 
      "BN": null, 
      "DE": null, 
      "BH": null, 
      "HX": null, 
      "DA": [
        1, 
        2, 
        3, 
        4, 
        9, 
        10, 
        11, 
        12, 
        13
      ], 
      "WV": null, 
      "CH": null, 
      "DY": null, 
      "WR": null, 
      "BR": [
        8
      ], 
      "BS": null, 
      "E": [
        77
      ], 
      "WA": null, 
      "ST": null, 
      "HG": null, 
      "HD": null, 
      "PR": null, 
      "LE": null, 
      "BB": null, 
      "NN": null, 
      "LA": null, 
      "LN": null, 
      "TW": [
        15, 
        16, 
        17, 
        18, 
        19, 
        20
      ], 
      "NE": null, 
      "NG": null, 
      "HR": null, 
      "LU": null, 
      "LS": null, 
      "IP": null, 
      "NP": null, 
      "RM": [
        4, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        27, 
        28, 
        29, 
        30, 
        31, 
        32, 
        33, 
        34, 
        35, 
        36, 
        37, 
        38, 
        39, 
        40, 
        41, 
        42, 
        43, 
        44, 
        45, 
        46, 
        47, 
        48, 
        49, 
        50
      ], 
      "NR": null, 
      "TS": null, 
      "RH": null, 
      "HP": null, 
      "SN": null, 
      "WD": null, 
      "GU": null, 
      "B": null, 
      "CO": null, 
      "CM": null, 
      "CB": null, 
      "OX": null, 
      "M": null, 
      "AL": null, 
      "CF": null, 
      "RG": null, 
      "S": null, 
      "TF": null, 
      "WN": null, 
      "CR": [
        3, 
        6, 
        9
      ], 
      "GL": null, 
      "CW": null, 
      "CV": null, 
      "IG": [
        7, 
        9, 
        10
      ], 
      "SR": null, 
      "ME": null, 
      "PE": null, 
      "SY": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        21, 
        22
      ], 
      "OL": null, 
      "SS": null, 
      "SG": null, 
      "YO": null, 
      "SP": null, 
      "SW": [
        99
      ], 
      "MK": null, 
      "PO": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22
      ], 
      "SK": null, 
      "SO": null, 
      "L": null, 
      "EN": [
        6, 
        7, 
        8, 
        9, 
        10, 
        11
      ], 
      "KT": [
        7, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24
      ], 
      "WS": null, 
      "TA": null, 
      "HU": null, 
      "SE": [
        99
      ]
    }, 
    "name": "Most of England and Rest of Wales"
  }, 
  "nireland": {
    "rid": "nireland", 
    "codes": {
      "BT": null
    }, 
    "name": "Belfast and N. Ireland"
  }, 
  "scotland-highlands-near": {
    "rid": "scotland-highlands-near", 
    "codes": {
      "PH": [
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        27, 
        28, 
        29, 
        30, 
        31, 
        32, 
        33, 
        34, 
        35, 
        36, 
        37, 
        38, 
        39, 
        40, 
        41, 
        45, 
        46, 
        47, 
        48, 
        49, 
        50
      ], 
      "AB": null, 
      "KW": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14
      ], 
      "PA": [
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        27, 
        28, 
        29, 
        30, 
        31, 
        32, 
        33, 
        35, 
        36, 
        37, 
        38, 
        39, 
        40, 
        41
      ], 
      "IV": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        27, 
        28, 
        30, 
        31, 
        32, 
        36, 
        55, 
        56, 
        63
      ]
    }, 
    "name": "Scotland - near highlands"
  }, 
  "special": {
    "rid": "special", 
    "codes": {
      "PA": [
        34
      ]
    }, 
    "name": "Ring for details"
  }, 
  "cardigan": {
    "rid": "cardigan", 
    "codes": {
      "SA": [
        35, 
        36, 
        37, 
        38, 
        41, 
        43, 
        44, 
        45
      ]
    }, 
    "name": "Cardigan Area"
  }, 
  "eire-other": {
    "rid": "eire-other", 
    "codes": {
      "IE": [
        1, 
        2, 
        3, 
        4, 
        5, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26
      ]
    }, 
    "name": "Eire - Other"
  }, 
  "cardigan-wide": {
    "rid": "cardigan-wide", 
    "codes": {
      "SA": [
        19, 
        31, 
        32, 
        33, 
        34, 
        39, 
        40, 
        42, 
        46, 
        47, 
        48, 
        61, 
        62, 
        63, 
        64, 
        65, 
        66, 
        67, 
        68, 
        69, 
        70, 
        71, 
        72, 
        73
      ], 
      "SY": [
        23, 
        25
      ]
    }, 
    "name": "Cardigan Wider Area"
  }, 
  "london-ec": {
    "rid": "london-ec", 
    "codes": {
      "E": [
        1
      ], 
      "WC": null, 
      "EC": null
    }, 
    "name": "London - Central - EC, WC, E1"
  }, 
  "scotland-highlands-really-far": {
    "rid": "scotland-highlands-really-far", 
    "codes": {
      "KA": [
        28
      ], 
      "PA": [
        60, 
        61, 
        76, 
        77, 
        78
      ], 
      "PH": [
        42, 
        43, 
        44
      ]
    }, 
    "name": "Scotland - furthest highlands and islands"
  }, 
  "swansea": {
    "rid": "swansea", 
    "codes": {
      "SA": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        20
      ]
    }, 
    "name": "Swansea Area"
  }, 
  "england-really-southwest": {
    "rid": "england-really-southwest", 
    "codes": {
      "TR": null, 
      "PL": [
        12, 
        13, 
        14, 
        15, 
        17, 
        23, 
        24, 
        25
      ]
    }, 
    "name": "Furthest South West England"
  }, 
  "channelisles": {
    "rid": "channelisles", 
    "codes": {
      "JE": null, 
      "GY": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8
      ]
    }, 
    "name": "Channel Isles"
  }, 
  "wales-midwest": {
    "rid": "wales-midwest", 
    "codes": {
      "TN": null, 
      "CA": null, 
      "LD": null, 
      "SY": [
        16, 
        17, 
        18, 
        19, 
        20
      ], 
      "CT": null
    }, 
    "name": "Other mid and west Wales"
  }, 
  "london-other": {
    "rid": "london-other", 
    "codes": {
      "EN": [
        1, 
        2, 
        3, 
        4, 
        5
      ], 
      "E": [
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        15, 
        16, 
        17, 
        18
      ], 
      "RM": [
        1, 
        2, 
        3, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13
      ], 
      "SM": null, 
      "TW": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14
      ], 
      "UB": null, 
      "SW": [
        2, 
        12, 
        14, 
        15, 
        16, 
        17, 
        19, 
        20
      ], 
      "DA": [
        5, 
        6, 
        7, 
        8, 
        14, 
        15, 
        16, 
        17, 
        18
      ], 
      "W": [
        5, 
        7, 
        13
      ], 
      "N": [
        2, 
        3, 
        4, 
        6, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22
      ], 
      "SE": [
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        12, 
        13, 
        14, 
        15, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        27, 
        28
      ], 
      "BR": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7
      ], 
      "KT": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        8, 
        9
      ], 
      "CR": [
        0, 
        2, 
        4, 
        5, 
        7, 
        8
      ], 
      "HA": null, 
      "IG": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        8, 
        11
      ], 
      "NW": [
        2, 
        3, 
        4, 
        7, 
        9, 
        10, 
        11
      ]
    }, 
    "name": "London - Other"
  }, 
  "scotland-highlands-far": {
    "rid": "scotland-highlands-far", 
    "codes": {
      "KA": [
        27
      ], 
      "HS": null, 
      "IV": [
        40, 
        41, 
        42, 
        43, 
        44, 
        45, 
        46, 
        47, 
        48, 
        49, 
        51, 
        52, 
        53, 
        54
      ], 
      "PA": [
        20, 
        42, 
        43, 
        44, 
        45, 
        46, 
        47, 
        48, 
        49, 
        62, 
        63, 
        64, 
        65, 
        66, 
        67, 
        68, 
        69, 
        70, 
        71, 
        72, 
        73, 
        74, 
        75
      ], 
      "KW": [
        15, 
        16, 
        17
      ], 
      "ZE": null
    }, 
    "name": "Scotland - far highlands and islands"
  }, 
  "scotland-lowlands": {
    "rid": "scotland-lowlands", 
    "codes": {
      "KA": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19, 
        20, 
        21, 
        22, 
        23, 
        24, 
        25, 
        26, 
        29, 
        30
      ], 
      "EH": null, 
      "G": null, 
      "DG": null, 
      "PA": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18, 
        19
      ], 
      "ML": null, 
      "KY": null, 
      "FK": null, 
      "TD": null
    }, 
    "name": "Scotland - lowlands"
  }, 
  "eire-dublin": {
    "rid": "eire-dublin", 
    "codes": {
      "IE": [
        6
      ]
    }, 
    "name": "Eire - Dublin"
  }, 
  "england-southwest": {
    "rid": "england-southwest", 
    "codes": {
      "EX": null, 
      "PL": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10
      ], 
      "TQ": null
    }, 
    "name": "Far South West England"
  }, 
  "isleofman": {
    "rid": "isleofman", 
    "codes": {
      "IM": null, 
      "PO": [
        30, 
        31, 
        32, 
        33, 
        34, 
        35, 
        36, 
        37, 
        38, 
        39, 
        40, 
        41
      ]
    }, 
    "name": "Isle of Man, Isle of Wight"
  }, 
  "scotland-highlands-central": {
    "rid": "scotland-highlands-central", 
    "codes": {
      "PH": [
        1, 
        2, 
        3, 
        4, 
        5, 
        6, 
        7, 
        8, 
        9, 
        10, 
        11, 
        12, 
        13, 
        14, 
        15, 
        16, 
        17, 
        18
      ], 
      "DD": null
    }, 
    "name": "Scotland - central highlands"
  }
};
var regexps = [
  {
    "re": "^SA(35|36|37|38|41|43|44|45)", 
    "rid": "cardigan"
  }, 
  {
    "re": "^SA(19|31|32|33|34|39|40|42|46|47|48|61|62|63|64|65|66|67|68|69|70|71|72|73)", 
    "rid": "cardigan-wide"
  }, 
  {
    "re": "^SY(23|25)", 
    "rid": "cardigan-wide"
  }, 
  {
    "re": "^SA((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|20)", 
    "rid": "swansea"
  }, 
  {
    "re": "^TN", 
    "rid": "wales-midwest"
  }, 
  {
    "re": "^CA", 
    "rid": "wales-midwest"
  }, 
  {
    "re": "^LD", 
    "rid": "wales-midwest"
  }, 
  {
    "re": "^SY(16|17|18|19|20)", 
    "rid": "wales-midwest"
  }, 
  {
    "re": "^CT", 
    "rid": "wales-midwest"
  }, 
  {
    "re": "^LL", 
    "rid": "wales-north"
  }, 
  {
    "re": "^BD", 
    "rid": "england-other"
  }, 
  {
    "re": "^DN", 
    "rid": "england-other"
  }, 
  {
    "re": "^DL", 
    "rid": "england-other"
  }, 
  {
    "re": "^SL", 
    "rid": "england-other"
  }, 
  {
    "re": "^BA", 
    "rid": "england-other"
  }, 
  {
    "re": "^DH", 
    "rid": "england-other"
  }, 
  {
    "re": "^WF", 
    "rid": "england-other"
  }, 
  {
    "re": "^BL", 
    "rid": "england-other"
  }, 
  {
    "re": "^FY", 
    "rid": "england-other"
  }, 
  {
    "re": "^BN", 
    "rid": "england-other"
  }, 
  {
    "re": "^DE", 
    "rid": "england-other"
  }, 
  {
    "re": "^BH", 
    "rid": "england-other"
  }, 
  {
    "re": "^HX", 
    "rid": "england-other"
  }, 
  {
    "re": "^DA((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(9[^0-9])|10|11|12|13)", 
    "rid": "england-other"
  }, 
  {
    "re": "^WV", 
    "rid": "england-other"
  }, 
  {
    "re": "^CH", 
    "rid": "england-other"
  }, 
  {
    "re": "^DY", 
    "rid": "england-other"
  }, 
  {
    "re": "^WR", 
    "rid": "england-other"
  }, 
  {
    "re": "^BR((8[^0-9]))", 
    "rid": "england-other"
  }, 
  {
    "re": "^BS", 
    "rid": "england-other"
  }, 
  {
    "re": "^E(77)", 
    "rid": "england-other"
  }, 
  {
    "re": "^WA", 
    "rid": "england-other"
  }, 
  {
    "re": "^ST", 
    "rid": "england-other"
  }, 
  {
    "re": "^HG", 
    "rid": "england-other"
  }, 
  {
    "re": "^HD", 
    "rid": "england-other"
  }, 
  {
    "re": "^PR", 
    "rid": "england-other"
  }, 
  {
    "re": "^LE", 
    "rid": "england-other"
  }, 
  {
    "re": "^BB", 
    "rid": "england-other"
  }, 
  {
    "re": "^NN", 
    "rid": "england-other"
  }, 
  {
    "re": "^LA", 
    "rid": "england-other"
  }, 
  {
    "re": "^LN", 
    "rid": "england-other"
  }, 
  {
    "re": "^TW(15|16|17|18|19|20)", 
    "rid": "england-other"
  }, 
  {
    "re": "^NE", 
    "rid": "england-other"
  }, 
  {
    "re": "^NG", 
    "rid": "england-other"
  }, 
  {
    "re": "^HR", 
    "rid": "england-other"
  }, 
  {
    "re": "^LU", 
    "rid": "england-other"
  }, 
  {
    "re": "^LS", 
    "rid": "england-other"
  }, 
  {
    "re": "^IP", 
    "rid": "england-other"
  }, 
  {
    "re": "^NP", 
    "rid": "england-other"
  }, 
  {
    "re": "^RM((4[^0-9])|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31|32|33|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|49|50)", 
    "rid": "england-other"
  }, 
  {
    "re": "^NR", 
    "rid": "england-other"
  }, 
  {
    "re": "^TS", 
    "rid": "england-other"
  }, 
  {
    "re": "^RH", 
    "rid": "england-other"
  }, 
  {
    "re": "^HP", 
    "rid": "england-other"
  }, 
  {
    "re": "^SN", 
    "rid": "england-other"
  }, 
  {
    "re": "^WD", 
    "rid": "england-other"
  }, 
  {
    "re": "^GU", 
    "rid": "england-other"
  }, 
  {
    "re": "^B[0-9]", 
    "rid": "england-other"
  }, 
  {
    "re": "^CO", 
    "rid": "england-other"
  }, 
  {
    "re": "^CM", 
    "rid": "england-other"
  }, 
  {
    "re": "^CB", 
    "rid": "england-other"
  }, 
  {
    "re": "^OX", 
    "rid": "england-other"
  }, 
  {
    "re": "^M[0-9]", 
    "rid": "england-other"
  }, 
  {
    "re": "^AL", 
    "rid": "england-other"
  }, 
  {
    "re": "^CF", 
    "rid": "england-other"
  }, 
  {
    "re": "^RG", 
    "rid": "england-other"
  }, 
  {
    "re": "^S[0-9]", 
    "rid": "england-other"
  }, 
  {
    "re": "^TF", 
    "rid": "england-other"
  }, 
  {
    "re": "^WN", 
    "rid": "england-other"
  }, 
  {
    "re": "^CR((3[^0-9])|(6[^0-9])|(9[^0-9]))", 
    "rid": "england-other"
  }, 
  {
    "re": "^GL", 
    "rid": "england-other"
  }, 
  {
    "re": "^CW", 
    "rid": "england-other"
  }, 
  {
    "re": "^CV", 
    "rid": "england-other"
  }, 
  {
    "re": "^IG((7[^0-9])|(9[^0-9])|10)", 
    "rid": "england-other"
  }, 
  {
    "re": "^SR", 
    "rid": "england-other"
  }, 
  {
    "re": "^ME", 
    "rid": "england-other"
  }, 
  {
    "re": "^PE", 
    "rid": "england-other"
  }, 
  {
    "re": "^SY((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|21|22)", 
    "rid": "england-other"
  }, 
  {
    "re": "^OL", 
    "rid": "england-other"
  }, 
  {
    "re": "^SS", 
    "rid": "england-other"
  }, 
  {
    "re": "^SG", 
    "rid": "england-other"
  }, 
  {
    "re": "^YO", 
    "rid": "england-other"
  }, 
  {
    "re": "^SP", 
    "rid": "england-other"
  }, 
  {
    "re": "^SW(99)", 
    "rid": "england-other"
  }, 
  {
    "re": "^MK", 
    "rid": "england-other"
  }, 
  {
    "re": "^PO((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22)", 
    "rid": "england-other"
  }, 
  {
    "re": "^SK", 
    "rid": "england-other"
  }, 
  {
    "re": "^SO", 
    "rid": "england-other"
  }, 
  {
    "re": "^L[0-9]", 
    "rid": "england-other"
  }, 
  {
    "re": "^EN((6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11)", 
    "rid": "england-other"
  }, 
  {
    "re": "^KT((7[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24)", 
    "rid": "england-other"
  }, 
  {
    "re": "^WS", 
    "rid": "england-other"
  }, 
  {
    "re": "^TA", 
    "rid": "england-other"
  }, 
  {
    "re": "^HU", 
    "rid": "england-other"
  }, 
  {
    "re": "^SE(99)", 
    "rid": "england-other"
  }, 
  {
    "re": "^E((2[^0-9])|14)", 
    "rid": "london-central"
  }, 
  {
    "re": "^SW((1[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|13|18)", 
    "rid": "london-central"
  }, 
  {
    "re": "^N((1[^0-9])|(5[^0-9])|(7[^0-9]))", 
    "rid": "london-central"
  }, 
  {
    "re": "^W((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(6[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|14)", 
    "rid": "london-central"
  }, 
  {
    "re": "^SE((1[^0-9])|11|16|17)", 
    "rid": "london-central"
  }, 
  {
    "re": "^NW((1[^0-9])|(5[^0-9])|(6[^0-9])|(8[^0-9]))", 
    "rid": "london-central"
  }, 
  {
    "re": "^E((1[^0-9]))", 
    "rid": "london-ec"
  }, 
  {
    "re": "^WC", 
    "rid": "london-ec"
  }, 
  {
    "re": "^EC", 
    "rid": "london-ec"
  }, 
  {
    "re": "^EN((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9]))", 
    "rid": "london-other"
  }, 
  {
    "re": "^E((3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|15|16|17|18)", 
    "rid": "london-other"
  }, 
  {
    "re": "^RM((1[^0-9])|(2[^0-9])|(3[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13)", 
    "rid": "london-other"
  }, 
  {
    "re": "^SM", 
    "rid": "london-other"
  }, 
  {
    "re": "^TW((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14)", 
    "rid": "london-other"
  }, 
  {
    "re": "^UB", 
    "rid": "london-other"
  }, 
  {
    "re": "^SW((2[^0-9])|12|14|15|16|17|19|20)", 
    "rid": "london-other"
  }, 
  {
    "re": "^DA((5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|14|15|16|17|18)", 
    "rid": "london-other"
  }, 
  {
    "re": "^W((5[^0-9])|(7[^0-9])|13)", 
    "rid": "london-other"
  }, 
  {
    "re": "^N((2[^0-9])|(3[^0-9])|(4[^0-9])|(6[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22)", 
    "rid": "london-other"
  }, 
  {
    "re": "^SE((2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|12|13|14|15|18|19|20|21|22|23|24|25|26|27|28)", 
    "rid": "london-other"
  }, 
  {
    "re": "^BR((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9]))", 
    "rid": "london-other"
  }, 
  {
    "re": "^KT((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(8[^0-9])|(9[^0-9]))", 
    "rid": "london-other"
  }, 
  {
    "re": "^CR((0[^0-9])|(2[^0-9])|(4[^0-9])|(5[^0-9])|(7[^0-9])|(8[^0-9]))", 
    "rid": "london-other"
  }, 
  {
    "re": "^HA", 
    "rid": "london-other"
  }, 
  {
    "re": "^IG((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(8[^0-9])|11)", 
    "rid": "london-other"
  }, 
  {
    "re": "^NW((2[^0-9])|(3[^0-9])|(4[^0-9])|(7[^0-9])|(9[^0-9])|10|11)", 
    "rid": "london-other"
  }, 
  {
    "re": "^EX", 
    "rid": "england-southwest"
  }, 
  {
    "re": "^PL((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10)", 
    "rid": "england-southwest"
  }, 
  {
    "re": "^TQ", 
    "rid": "england-southwest"
  }, 
  {
    "re": "^TR", 
    "rid": "england-really-southwest"
  }, 
  {
    "re": "^PL(12|13|14|15|17|23|24|25)", 
    "rid": "england-really-southwest"
  }, 
  {
    "re": "^IM", 
    "rid": "isleofman"
  }, 
  {
    "re": "^PO(30|31|32|33|34|35|36|37|38|39|40|41)", 
    "rid": "isleofman"
  }, 
  {
    "re": "^KA((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|29|30)", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^EH", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^G[0-9]", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^DG", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^PA((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19)", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^ML", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^KY", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^FK", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^TD", 
    "rid": "scotland-lowlands"
  }, 
  {
    "re": "^PH(19|20|21|22|23|24|25|26|27|28|29|30|31|32|33|34|35|36|37|38|39|40|41|45|46|47|48|49|50)", 
    "rid": "scotland-highlands-near"
  }, 
  {
    "re": "^AB", 
    "rid": "scotland-highlands-near"
  }, 
  {
    "re": "^KW((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14)", 
    "rid": "scotland-highlands-near"
  }, 
  {
    "re": "^PA(21|22|23|24|25|26|27|28|29|30|31|32|33|35|36|37|38|39|40|41)", 
    "rid": "scotland-highlands-near"
  }, 
  {
    "re": "^IV((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|30|31|32|36|55|56|63)", 
    "rid": "scotland-highlands-near"
  }, 
  {
    "re": "^PH((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18)", 
    "rid": "scotland-highlands-central"
  }, 
  {
    "re": "^DD", 
    "rid": "scotland-highlands-central"
  }, 
  {
    "re": "^KA(27)", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^HS", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^IV(40|41|42|43|44|45|46|47|48|49|51|52|53|54)", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^PA(20|42|43|44|45|46|47|48|49|62|63|64|65|66|67|68|69|70|71|72|73|74|75)", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^KW(15|16|17)", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^ZE", 
    "rid": "scotland-highlands-far"
  }, 
  {
    "re": "^KA(28)", 
    "rid": "scotland-highlands-really-far"
  }, 
  {
    "re": "^PA(60|61|76|77|78)", 
    "rid": "scotland-highlands-really-far"
  }, 
  {
    "re": "^PH(42|43|44)", 
    "rid": "scotland-highlands-really-far"
  }, 
  {
    "re": "^JE", 
    "rid": "channelisles"
  }, 
  {
    "re": "^GY((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(6[^0-9])|(7[^0-9])|(8[^0-9]))", 
    "rid": "channelisles"
  }, 
  {
    "re": "^BT", 
    "rid": "nireland"
  }, 
  {
    "re": "^IE((6[^0-9]))", 
    "rid": "eire-dublin"
  }, 
  {
    "re": "^IE((1[^0-9])|(2[^0-9])|(3[^0-9])|(4[^0-9])|(5[^0-9])|(7[^0-9])|(8[^0-9])|(9[^0-9])|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26)", 
    "rid": "eire-other"
  }, 
  {
    "re": "^PA(34)", 
    "rid": "special"
  }
];
